import { ShardSearchEntryDetails } from '../@types';
import { createGetEndpoint, getQueryString, HttpHeader } from '@sonar-software/sonar-http';

export type GetShardCatalogDetailsRequest = {
	type: string;
	key: string;
	shardName?: string;
};

export type GetShardCatalogDetailsResponse = ShardSearchEntryDetails;

export const getShardCatalogDetails = createGetEndpoint<GetShardCatalogDetailsRequest, GetShardCatalogDetailsResponse>(
	(request) =>
		`/api/v3/core/search/shard-catalog-details?${getQueryString({
			key: request?.key,
			type: request?.type
		})}`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		skipAuthRefresh: true
	}
);
